module.exports = __webpack_public_path__ + "static/img/jiqiren_03.ec5217c.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/jiqiren_03.png
// module id = V+0G
// module chunks = 0